import React from 'react'
import { Button } from '@mui/material'
import DialogWrapper from '../../../../components/core-ui/DialogWrapper'

const ConfirmationDialog = ({ open, title, message, onConfirm, onClose }) => {
  return (
    <DialogWrapper
      open={open}
      onClose={onClose}
      heading={title}
      actions={
        <>
          <Button onClick={onClose} variant="outlined" color="primary">
            No
          </Button>
          <Button color="primary" variant="contained" onClick={onConfirm}>
            Yes
          </Button>
        </>
      }
    >
      {message}
    </DialogWrapper>
  )
}

export default ConfirmationDialog
